import React from 'react';
import { innovationData, valuesData } from '../mock';
import { Card, CardContent } from './ui/card';
import { Lightbulb, Leaf, Target, Globe, Award, Cpu } from 'lucide-react';
import { Badge } from './ui/badge';

const iconMap = {
  lightbulb: Lightbulb,
  leaf: Leaf,
  target: Target,
  globe: Globe,
  award: Award,
  cpu: Cpu
};

const Innovation = () => {
  return (
    <section id="innovacion" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Innovation Section */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#0A3A48] mb-4">
              {innovationData.title}
            </h2>
            <div className="w-24 h-1 bg-[#5E8B7E] mx-auto mb-6"></div>
          </div>

          <div className="max-w-4xl mx-auto">
            <p className="text-xl text-[#4A4A4A] text-center mb-8 leading-relaxed">
              {innovationData.description}
            </p>
            <div className="flex flex-wrap justify-center gap-3">
              {innovationData.areas.map((area, index) => (
                <Badge
                  key={index}
                  className="px-6 py-3 text-base bg-[#5E8B7E] hover:bg-[#0A3A48] text-white transition-colors cursor-pointer"
                >
                  {area}
                </Badge>
              ))}
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div>
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#0A3A48] mb-4">Valores Corporativos</h2>
            <div className="w-24 h-1 bg-[#5E8B7E] mx-auto"></div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {valuesData.map((value, index) => {
              const IconComponent = iconMap[value.icon];
              return (
                <Card
                  key={index}
                  className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-gradient-to-br from-white to-[#5E8B7E]/5"
                >
                  <CardContent className="p-6 text-center">
                    <div className="inline-flex p-4 bg-[#5E8B7E]/10 rounded-full mb-4">
                      <IconComponent className="text-[#5E8B7E]" size={32} />
                    </div>
                    <h3 className="text-xl font-bold text-[#0A3A48] mb-3">
                      {value.title}
                    </h3>
                    <p className="text-[#4A4A4A] leading-relaxed">
                      {value.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Innovation;